import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store'
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    meta:{title:'登入',isLogin:false},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Login.vue"),
  },
  {
    path: "/",
    name: "Home",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Home.vue"),
  },
  {
    path: "/Notice",
    name: "Notice",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Notice/Index.vue"),
  },
  {
    path: "/NoticeDetails",
    name: "NoticeDetails",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Notice/details.vue"),
  },
  {
    path: "/Catering",
    name: "Catering",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Catering/Index.vue"),
  },
  {
    path: "/Catering/List",
    name: "Catering/List",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Catering/List.vue"),
  },
  {
    path: "/Meal",
    name: "Meal",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/Meal/Index.vue"),
  },
  {
    path: "/System",
    name: "System",
    meta:{isLogin:true},
    component: () => import(/* webpackChunkName: "about" */ "@/views/System/Index.vue"),
  },
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const scrollBehavior = function scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }else {
        return { x: 0, y: 0 }
     }
  };
const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior
});

router.beforeEach((to,from,next)=>{
  document.title = '皇太后餐點管理'
  if(to.matched.some(res=>res.meta.isLogin)){//判断是否需要登录
    if (window.localStorage.getItem('token')) {
      const hasRoles = store.getters.accessedRoutes && store.getters.accessedRoutes.length > 0
      if(!hasRoles) {
        store.dispatch('user/getInfo')
      }
      next();

    }else{
      next({
        path:"/login",
        query:{
          redirect:to.fullPath
        }
      });
    }
  }else{
    next()
  }
});

export default router;
